module.exports = __webpack_public_path__ + "static/img/tip-2.54519a1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/guide/usdt5/tip-2.png
// module id = g4bv
// module chunks = 1